import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { ProgressSpinner } from "primereact/progressspinner";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import ApiServices from "../../service/api/ApiServices";
import { DataView } from "primereact/dataview";
import { TabPanel, TabView } from "primereact/tabview";
import { failureToast, successToast } from "../Common/CommonFunctions";
import { Toast } from "primereact/toast";

const apiServices = new ApiServices();

export const GSFProductList = ({ props, preOrderNo, selectedScheme, onBack }) => {
    debugger
    console.log("Props in Product List: ", props);

    const [productslist, setProductslist] = useState([]);
    const [orderPlaced, setOrderPlaced] = useState(false);
    const [reviewOrderFlag, setReviewOrderFlag] = useState(false);
    const [loading, setLoading] = useState(false);

    const [schemeAmount, setSchemeAmount] = useState(0);
    const [productAmount, setProductAmount] = useState(0);

    const [totalAmount, setTotalAmount] = useState(0);
    const [taxAmount, setTaxAmount] = useState(0);
    const [finalAmount, setFinalAmount] = useState(0);

    const [addToCart, setAddToCart] = useState([]);
    const [layout, setLayout] = useState("grid");
    const [sortOrder, setSortOrder] = useState(1);
    const [sortField, setSortField] = useState("name");
    const [showPopup, setShowPopup] = useState(false);
    const [hideOrderDialog, sethideOrderDialog] = useState(false);
    const [orderMessage, setOrderMessage] = useState("");
    const [orderSuccess, setOrderSuccess] = useState(false);

    useEffect(() => {
        getGSFProducts();
        calculateSchemeAmount();
    }, []);

    const toast = useRef(null);


    const calculateSchemeAmount = () => {
        let amount = 0;
        selectedScheme.forEach((element) => {
            if (element.quantity) {
                amount += element.price * element.quantity;
            }
        });
        setSchemeAmount(amount);
        return amount;
    };

    const getGSFProducts = async () => {
        setLoading(true);
        let brand = "TAPRI";
        const zoho_id = "3786249000049282066";
        const isKettle = selectedScheme.some((s) => s.zoho_id === zoho_id);

        if (selectedScheme.length === 1) {
            brand = isKettle ? "MERI_TAPRI" : "TAPRI";
        } else if (selectedScheme.length > 1) {
            brand = isKettle ? ["MERI_TAPRI", "TAPRI"] : "TAPRI";
        }

        let response = await apiServices.getGSFProducts({ brand });
        response = response?.data.response_obj;
        setProductslist(response || []);
        setLoading(false);
    };

    const addItemsToCart = () => {
        const cartItems = addToCart.filter((item) => item.quantity > 0);

        if (cartItems.length === 0) {
            alert("Please select product to proceed.");
            return;
        }

        const productTotal = cartItems
            .filter((item) => item.type === "product")
            .reduce((sum, item) => sum + item.price * item.quantity, 0);

        setProductAmount(productTotal);

        if (productTotal < schemeAmount) {
            setShowPopup(true);
            return;
        }

        setTotalAmount(productTotal);
        // const tax = productTotal * 0.18;
        // setTaxAmount(tax);
        setFinalAmount(productTotal);

        setAddToCart(cartItems);
        setReviewOrderFlag(true);
    };

    const productItemTemplate = (data) => {
        return (
            <div className="p-col-12 p-md-3">
                <div className="product-grid-item card">
                    <div className="product-grid-item-content p-mb-2">
                        <img
                            src={data.images}
                            alt={data?.name}
                            style={{
                                boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2)",
                                width: "80%",
                                height: "250px",
                                objectFit: "cover",
                            }}
                        />
                        <div className="product-name">
                            <strong>{data?.name}</strong> <br />
                            {/* <b>Type: {data?.type} <br /></b> */}
                            <b>Qty: {data?.quantity || 0}</b> <br />
                            <b>Price: ₹{data?.price || 0} <br /></b>
                            <b>SubTotal: ₹{data?.price * data?.quantity} <br /></b>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    let orderData = {
        customer_id: props.id,
        salesPerson_id: props.salesPerson_objectId,
        combos: [...selectedScheme, ...addToCart],
        source: "DASHBOARD",
        billing_type: "PacketWise",
        payment_mode: "ONLINE",
        amount: {
            taxes: 0,
            machine_amount: 0,
            refill_amount: 0,
            discount: 0,
            subtotal: finalAmount,
            shipping_charges: props.shipping_charges || 0,
            total: finalAmount + (props.shipping_charges || 0),
            free_amount: 0,
        },
        shipping_address: {
            name: props.first_name,
            city: props.shipping_address?.city || "",
            state: props.shipping_address?.state || "",
            pincode: props.shipping_address?.pincode || "",
        },
        billing_address: {
            is_same: props.is_same,
            name: props.first_name,
            address: props.billing_address?.address || "",
            city: props.billing_address?.city || "",
            state: props.billing_address?.state || "",
            pincode: props.billing_address?.pincode || "",
        },
        personal_prefix: props.prefix,
        personal_first_name: props.first_name,
        personal_last_name: props.last_name,
        phone_number: props.phone_number,
        pre_order_id: preOrderNo,
    };

    const placeOrder = async (orderData) => {
        try {
            setLoading(true);
            const response = await apiServices.createGSFOrder(orderData);
            console.log("Order Placed: ", response);

            if (response?.data?.response_code) {
                successToast(toast, "Order Placed Successfully");
                setOrderMessage("🎉 Your order has been placed successfully!");
                setOrderSuccess(true);
            } else {
                failureToast(toast, `Failed to Place Order, ${response?.data?.msg}`);
                setOrderMessage(`❌ Failed to place order: ${response?.data?.msg}`);
                setOrderSuccess(false);
            }

            sethideOrderDialog(true);

            // Auto close after 3 sec
            setTimeout(() => {
                sethideOrderDialog(false);
                if (orderSuccess) {
                    setOrderPlaced(true); 
                    setReviewOrderFlag(false);
                }
            }, 3000);

        } catch (error) {
            failureToast(toast, "Something went wrong. Please try again.");
            setOrderMessage("❌ Something went wrong. Please try again.");
            setOrderSuccess(false);
            sethideOrderDialog(true);
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <Toast ref={toast} />
            {loading ? (
                <div className="spinner-div">
                    <center>
                        <ProgressSpinner strokeWidth="7" animationDuration="4s" />
                    </center>
                </div>
            ) : (
                <>
                    {/* STEP 1: Product Selection */}
                    {!reviewOrderFlag && !orderPlaced && (
                        <div className="p-col-12">
                            <div className="card">
                                <Button
                                    className="p-custom-btn"
                                    label="Go Back"
                                    icon="pi pi-backward"
                                    iconPos="left"
                                    onClick={onBack}
                                />
                            </div>

                            <div className="card mt-5">
                                <h5 className="p-m-5">Select Products</h5>
                                <div className="p-grid p-nogutter p-justify-start">
                                    {productslist.map((item, index) => {
                                        const existing = addToCart.find(
                                            (p) => p.zoho_id === item.zoho_id
                                        );
                                        return (
                                            <div
                                                key={index}
                                                className="p-col-12 p-md-6 p-lg-3 p-p-2"
                                            >
                                                <div
                                                    className="card p-shadow-3 p-p-3"
                                                    style={{
                                                        borderRadius: "12px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <img
                                                        src={`https://assets.cheriseglobal.com/public/${item.images[0]}`}
                                                        alt={item.product_name}
                                                        style={{
                                                            width: "75%",
                                                            height: "200px",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                        }}
                                                    />
                                                    <h3 className="p-mt-3">
                                                        {item.product_name}
                                                    </h3>
                                                    <p>
                                                        <strong>
                                                            Product Name: {item.name}
                                                        </strong>
                                                    </p>
                                                    <p>
                                                        <strong>
                                                            Price: ₹
                                                            {item.prices?.list_price}
                                                        </strong>
                                                    </p>
                                                    <div className="p-col-5">
                                                        <div className="grid">
                                                            <div className="col-12">
                                                                {item.inventory === 0 ? (<span style={{ color: "red", fontWeight: "bold" }}>Out Of Stock</span>) : <InputNumber
                                                                    value={
                                                                        existing?.quantity || 0
                                                                    }
                                                                    onChange={(e) => {
                                                                        const qty = e.value || 0;
                                                                        setAddToCart((prev) => {
                                                                            const updated = [
                                                                                ...prev.filter(
                                                                                    (p) =>
                                                                                        p.zoho_id !==
                                                                                        item.zoho_id
                                                                                ),
                                                                            ];
                                                                            if (qty > 0) {
                                                                                updated.push({
                                                                                    _id: item._id,
                                                                                    zoho_id: item.zoho_id,
                                                                                    name: item.name,
                                                                                    price: item.prices?.list_price,
                                                                                    quantity: qty,
                                                                                    images: `https://assets.cheriseglobal.com/public/${item.images[0]}`,
                                                                                    type: "product",
                                                                                });
                                                                            }
                                                                            return updated;
                                                                        });
                                                                    }}
                                                                    showButtons
                                                                    buttonLayout="horizontal"
                                                                    min={0}
                                                                    max={999}
                                                                    inputStyle={{
                                                                        textAlign: "center",
                                                                        fontSize: "1.5rem",
                                                                        fontWeight: "600",
                                                                        width: "80px",
                                                                        height: "60px",
                                                                    }}
                                                                    incrementButtonClassName="p-button-success p-button-lg"
                                                                    decrementButtonClassName="p-button-danger p-button-lg"
                                                                    incrementButtonIcon="pi pi-plus"
                                                                    decrementButtonIcon="pi pi-minus"
                                                                />}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="flex justify-content-center mt-4">
                                    <Button
                                        className="p-button-lg p-col-12 p-mt-2"
                                        icon="pi pi-arrow-right"
                                        iconPos="right"
                                        label="Review Order"
                                        onClick={addItemsToCart}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {/* STEP 2: Review Order */}
                    {reviewOrderFlag && (
                        <div className="p-col-12">
                            <div className="card">
                                <Button
                                    className="p-custom-btn"
                                    label="Go Back"
                                    icon="pi pi-backward"
                                    iconPos="left"
                                    onClick={() => setReviewOrderFlag(false)}
                                />
                            </div>

                            {/* Order Summary */}
                            <TabView header="ORDER SUMMARY">
                                <TabPanel header="ORDER SUMMARY">
                                    <div className="card">
                                        <h3>Order Summary</h3>

                                        {/* Scrollable container */}
                                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                                            <DataView
                                                value={addToCart}
                                                layout={layout}
                                                blockScroll={false}
                                                paginator={false}   // disable paginator if you want scrollbar
                                                sortOrder={sortOrder}
                                                sortField={sortField}
                                                itemTemplate={productItemTemplate}
                                                loading={loading}
                                            />
                                        </div>
                                    </div>

                                    <div className="card">
                                        <h6>Subtotal : ₹{totalAmount}</h6>
                                        {/* <h6>Tax (18%) : ₹{taxAmount.toFixed(2)}</h6> */}
                                        <h4>Total : ₹{finalAmount.toFixed(2)}</h4>
                                        <Button
                                            className="p-button-lg p-col-12 p-mt-2"
                                            icon="pi pi-arrow-right"
                                            iconPos="right"
                                            label="Place Order"
                                            onClick={() => placeOrder(orderData)}
                                        />
                                    </div>
                                </TabPanel>
                            </TabView>
                        </div>
                    )}
                </>
            )}

            {/* 🚨 Popup dialog */}
            <Dialog
                header="Add More Products"
                visible={showPopup}
                style={{ width: "30vw" }}
                modal
                onHide={() => setShowPopup(false)}
                footer={
                    <Button
                        label="OK"
                        icon="pi pi-check"
                        onClick={() => setShowPopup(false)}
                        autoFocus
                    />
                }
            >
                <p className="font-medium">
                    Your selected products total (
                    <strong>₹{productAmount}</strong>) is less than the scheme
                    amount (<strong>₹{schemeAmount}</strong>). Please add more
                    products to proceed.
                </p>
            </Dialog>

            {/* 🚨 Order Success Dialog */}
            <Dialog
                header="Order Status"
                visible={hideOrderDialog}
                style={{ width: "25vw" }}
                modal
                onHide={() => sethideOrderDialog(false)}
                footer={
                    <Button
                        label="Close"
                        icon="pi pi-check"
                        onClick={() => sethideOrderDialog(false)}
                        autoFocus
                    />
                }
            >
                <p
                    className="font-medium"
                    style={{ color: orderSuccess ? "green" : "red" }}
                >
                    {orderMessage}
                </p>
            </Dialog>


        </>
    );
};
